import { Semanticpmpmvt7fldq2 as Semantic } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { isLetterOrDigit2kuxd9e198haf as isLetterOrDigit } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ForegroundSemanticClass;
function ForegroundSemantic() {
  if (ForegroundSemanticClass === VOID) {
    class $ extends Semantic() {
      static agi(color) {
        // Inline function 'kotlin.text.filter' call
        var tmp0 = color.paz();
        // Inline function 'kotlin.text.filterTo' call
        var destination = StringBuilder().d1();
        var inductionVariable = 0;
        var last = charSequenceLength(tmp0);
        if (inductionVariable < last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var element = charSequenceGet(tmp0, index);
            if (isLetterOrDigit(element)) {
              destination.xb(element);
            }
          }
           while (inductionVariable < last);
        var tmp$ret$2 = destination.toString();
        var $this = this.bd1('foreground' + tmp$ret$2);
        $this.zgh_1 = color;
        return $this;
      }
      cd1(theme) {
        return this.ed1(theme, VOID, VOID, VOID, VOID, VOID, VOID, this.zgh_1);
      }
      toString() {
        return 'ForegroundSemantic(color=' + this.zgh_1.toString() + ')';
      }
      hashCode() {
        return this.zgh_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ForegroundSemantic()))
          return false;
        if (!this.zgh_1.equals(other.zgh_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ForegroundSemantic');
    ForegroundSemanticClass = $;
  }
  return ForegroundSemanticClass;
}
function colored(_this__u8e3s4, color) {
  return _this__u8e3s4.hbb(ForegroundSemantic().agi(color));
}
//region block: exports
export {
  ForegroundSemantic as ForegroundSemantic2og103ajpnjfv,
  colored as colored3y8uibz1hk46,
};
//endregion

//# sourceMappingURL=colorManagement.mjs.map
